import React from 'react'
import PropTypes from 'prop-types';

export default function Excel(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M13.106 2.03a.68.68 0 0 0-.555-.143l-10.8 2.025a.673.673 0 0 0-.55.663v14.85c0 .324.23.603.55.662l10.8 2.026a.674.674 0 0 0 .8-.663V2.55a.673.673 0 0 0-.245-.52ZM12 20.636l-9.45-1.772V5.134L12 3.365v17.272Z"
        fill="#FFF"
      />
      <path
        d="M22.125 4.575h-9.45a.675.675 0 0 0 0 1.35h8.775v12.15h-8.775a.675.675 0 0 0 0 1.35h9.45a.675.675 0 0 0 .675-.675V5.25a.675.675 0 0 0-.675-.675Z"
        fill="#FFF"
      />
      <path
        d="M15.375 7.274h-2.7a.675.675 0 0 0 0 1.35h2.7a.675.675 0 0 0 0-1.35Zm0 2.701h-2.7a.675.675 0 0 0 0 1.35h2.7a.675.675 0 0 0 0-1.35Zm0 2.699h-2.7a.675.675 0 0 0 0 1.35h2.7a.675.675 0 0 0 0-1.35Zm0 2.7h-2.7a.675.675 0 0 0 0 1.35h2.7a.675.675 0 0 0 0-1.35Zm4.05-8.1h-1.35a.675.675 0 0 0 0 1.35h1.35a.675.675 0 0 0 0-1.35Zm0 2.701h-1.35a.675.675 0 0 0 0 1.35h1.35a.675.675 0 0 0 0-1.35Zm0 2.699h-1.35a.675.675 0 0 0 0 1.35h1.35a.675.675 0 0 0 0-1.35Zm0 2.7h-1.35a.675.675 0 0 0 0 1.35h1.35a.675.675 0 0 0 0-1.35Zm-8.941-1.119-4.725-5.4a.674.674 0 1 0-1.017.888l4.725 5.4a.673.673 0 0 0 .954.064.674.674 0 0 0 .063-.952Z"
        fill="#FFF"
      />
      <path
        d="M10.39 8.093a.675.675 0 0 0-.948.117l-4.725 6.075a.676.676 0 0 0 1.065.83l4.725-6.075a.675.675 0 0 0-.117-.947Z"
        fill="#FFF"
      />
    </svg>
  )
}
Excel.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};